import * as api from '../../api';
import * as extensionActions from './actions';
import { getSelectedIds as getProjectIds } from '../project/selectors';
import { getSelectedId as getCategoryId } from '../category/selectors';
import { getExtensionsById, getSelectedIds, getExpandedKeys } from './selectors';
import * as lastStateActions from '../lastState/actions';
import { ALL_EXTENSIONS_ID } from './model';
import { ALL_CATEGORIES_ID } from '../category/model';
import { takeLatest } from '../../listenerMiddleware';
import { loadDictionary } from '../filtersCache/loadDictionary';

export const extensionListeners = () => {
  watchLoadExtensionsRequested();
  watchLastState();
};

function watchLoadExtensionsRequested() {
  takeLatest(
    extensionActions.loadExtensionsRequested,
    async ({ payload }, { getState, dispatch, signal }) => {
      const projectIds = getProjectIds(getState());
      const categoryId = getCategoryId(getState());
      const requestParams = {
        projectIds,
        categoryId: categoryId === ALL_CATEGORIES_ID ? undefined : categoryId,
      };

      await loadDictionary(
        {
          dict: 'extension',
          params: requestParams,
          setLoading: extensionActions.setLoading,
          itemsChanged: (extensions) => extensionActions.extensionsChanged({ extensions }),
          // Бэкенд отдаёт словарь id → name, а слайсу нужен массив.
          request: () =>
            api
              .loadExtensions(requestParams)
              .then((r) =>
                r.success
                  ? Object.entries(r.data.response).map(([id, name]) => ({ id, name }))
                  : undefined,
              ),
          errorMessage: 'Extensions have not been loaded',
        },
        { getState, dispatch, signal },
      );
      if (signal.aborted) {
        return;
      }

      // Проверки консистентности идут всегда, даже когда сеть была пропущена.
      const { saveLastState } = payload;
      // Check selected ids
      const selectedIds = getSelectedIds(getState());
      const extensionsById = getExtensionsById(getState());
      const newSelectedIds = selectedIds.filter(
        (id) => id === ALL_EXTENSIONS_ID || extensionsById[id],
      );
      if (newSelectedIds.length !== selectedIds.length) {
        dispatch(
          extensionActions.extensionsSelected({
            ids: newSelectedIds.length ? newSelectedIds : [ALL_EXTENSIONS_ID],
            saveLastState,
          }),
        );
      }

      // Check expanded keys
      const expandedKeys = getExpandedKeys(getState());
      const newExpandedKeys = expandedKeys.filter(
        (id) => id === ALL_EXTENSIONS_ID || extensionsById[id],
      );
      if (newExpandedKeys.length !== expandedKeys.length) {
        dispatch(extensionActions.setExpandedKeys({ keys: newExpandedKeys, saveLastState }));
      }
    },
  );
}

function watchLastState() {
  takeLatest(
    [extensionActions.extensionsSelected, extensionActions.setExpandedKeys],
    ({ payload }, { dispatch }) => {
      if (payload.saveLastState) {
        dispatch(lastStateActions.saveRequested());
      }
    },
  );
}
